module.exports = __webpack_public_path__ + "static/media/Collections-weddings-Mobile.2fec97ae.jpg";